(function ( $ ) {

    $.fn.magnet = function() {
    	var magnets = [];
        $(this).each(function(i){
            var $that = $(this),
            	top = $that.offset().top,
            	height = $that.outerHeight(),
            	parentW = $that.parent().width();

            magnets.push({
            	target : $that,
            	top : top,
            	height : height,
            	fixed : false,
            	parent : parentW,
            });

            $window.resize(function(){
                magnets[i].parent = $that.parent().width();
                magnets[i].top = $that.offset().top;
                magnets[i].height = $that.outerHeight();

                if (magnets[i].fixed) {
                    $that.css('width', magnets[i].parent);
                }
            })
        });

        return $window.scroll(function(e) {
            e.preventDefault();

            magnets.map(function(elem, i){
                if ((elem.top - hh <= scrollTop && !elem.fixed && scrollTop <= fTop)) {
                	elem.fixed = true;
                	elem.target
                		.css('width', elem.parent)
                		.removeClass('fixed-bot')
                		.addClass('fixed');
                } else if (scrollBot > fTop) {
                	elem.target.addClass('fixed-bot');
                } else if (elem.top - hh > scrollTop){
                	elem.fixed = false;
                	elem.target
                		.css('width', '100%')
                		.removeClass('fixed fixed-bot');
                } else {
                	elem.target
                		.css('width', elem.parent)
                		.removeClass('fixed-bot')
                		.addClass('fixed');
                }
            });
        });
    };

}( jQuery ));

$(function(){
	if ($('.js-magnet').length) {
        $('.js-magnet').magnet();
    }
});